import { ChainId } from '@/sdk/constants';
import { SELECTED_NETWORK_NAME } from '@/helpers/networkParams.helper';

export const DEFAULT_CHAIN_ID = ChainId[`${SELECTED_NETWORK_NAME.toUpperCase()}_MAINNET`];
